import { Transactions } from "../../../shared/components/transactions/transactions";
import { UserTypes } from "../../../shared/constants";
export function BackofficeTransactions() {
  return <Transactions userType={UserTypes.Backoffice} />;
}
